import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress ResizeObserver loop error (benign warning from ReactFlow/resize observers)
// This error is harmless and occurs when resize observations can't be delivered in a single animation frame
// Patch ResizeObserver to prevent the error from being thrown
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback: ResizeObserverCallback) {
    super((entries, observer) => {
      // Use requestAnimationFrame to batch resize observations
      window.requestAnimationFrame(() => {
        try {
          callback(entries, observer);
        } catch (e) {
          // Silently ignore ResizeObserver callback errors
        }
      });
    });
  }
};

// Also catch any errors that still slip through
const resizeObserverErrHandler = (e: ErrorEvent) => {
  if (e.message?.includes('ResizeObserver loop') || 
      e.message?.includes('ResizeObserver loop completed with undelivered notifications')) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
    return true;
  }
};

window.addEventListener('error', resizeObserverErrHandler, true);

// Override console.error to suppress the warning there too
const originalConsoleError = console.error;
console.error = (...args) => {
  if (args[0]?.toString?.()?.includes?.('ResizeObserver loop')) {
    return;
  }
  originalConsoleError.apply(console, args);
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
